<template>
  <div>
    <!-- 考场状态弹窗 -->
    <div class="to_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.listType"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <el-checkbox-group v-model="listlabel">
            <el-checkbox
              v-for="(item, index) in listType"
              :key="index"
              :label="item.value"
              :disabled="
                item.value == 'kszh' ||
                  item.value == 'khxm' ||
                  item.value == 'ks'
              "
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.listType = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="determineList">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisibleObj: {
        listType: false
      },
      listlabel: ["kszh"],
      listType: [
        {
          label: "考生账号",
          value: "kszh",
          index: 0
        },
        {
          label: "考生姓名",
          value: "khxm",
          index: 1
        },
        {
          label: "科室",
          value: "ks",
          index: 2
        },
        {
          label: "职称",
          value: "zc",
          index: 3
        },
        {
          label: "职位",
          value: "zw",
          index: 4
        },
        {
          label: "出生年月",
          value: "csny",
          index: 5
        },
        {
          label: "工作年限",
          value: "gznx",
          index: 6
        },
        {
          label: "提交时间",
          value: "tjsj",
          index: 7
        }
      ]
    };
  },
  methods: {
    determineList() {
      let newarr = [];
      this.listlabel.forEach(item => {
        let a = this.$parent.newform.filter(zitem => {
          return item == zitem.value;
        });
        newarr.push(...a);
      });
      newarr = newarr.sort((a, b) => {
        return a.index - b.index; // 更具固定的index进行排序
      });
      this.$parent.formColumns = newarr;
      this.dialogVisibleObj.listType = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.to_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-checkbox {
    font-size: 28px;
  }
}
::v-deep .to_view .el-dialog {
  width: 441px;
  min-height: 300px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}
</style>
